// src/utils/request.js
import router from '@/router';
import axios from 'axios';
import {Message }from "element-ui";
// import {MessageBox }from "element-ui";

// 创建 axios 实例
const http = axios.create({
  baseURL: "https://serve.dhcang.com/api", // API 的 base_url
  timeout: 60000 // 请求超时时间
});
 
// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么，例如添加 token 等
    // config.headers['X-Token'] = 'your token';
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error); // for debug
    return Promise.reject(error);
  }
);
 
// 响应拦截器
http.interceptors.response.use(
  response => {
    const res = response.data;
    // 在这里对返回的数据进行处理，统一处理错误状态码 -1 登录超时
    if (res.code == -1) {  //登录超时  情况本地存储情况

      // MessageBox.alert(res.msg)  //  弹窗式进行提示
      Message({ // 消息提示
        message: res.msg,
        type: 'error'
      });
      if(window.location.pathname!='/' || window.location.pathname!='/index'){
        router.replace({
          path:'/index'
        })
      }

      localStorage.removeItem("userInfo");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("token");
      sessionStorage.removeItem("has_password");
      sessionStorage.removeItem('menu')
      
      window.location.reload()  // 刷新页面
    } else {
      return res;
    }
    // return res;
  },
  error => {
    console.error('Response error:', error); // for debug
    return Promise.reject(error);
  }
);
 
export default http;